import { DefaultInput } from './index'

export default {
    user_id: new DefaultInput('User'),
    role_id: new DefaultInput('Role'),
    company_id: new DefaultInput(),
    entity_id: new DefaultInput(),
}
